import { useLocalStorage } from "@/hooks/use-local-storage";
import { providerFactory } from "@/shared/providers/provider-factory";

// biome-ignore lint/suspicious/noEvolvingTypes: <explanation>
export const BetaFeatures = [];
export type BetaFeature = (typeof BetaFeatures)[number];

const [BetaFeaturesProvider, useBetaFeatures] = providerFactory(() => {
  const [features, setFeatures] = useLocalStorage<Record<
    BetaFeature,
    boolean
  > | null>("beta-features", null);

  const isBetaFeatureEnabled = (flag: BetaFeature): boolean => {
    return features ? (features[flag] ?? false) : false;
  };

  const setBetaFeatureEnabled = (flag: BetaFeature, enabled: boolean) => {
    setFeatures({ ...features, [flag]: enabled });
  };

  const enableBetaFeatures = () => {
    setFeatures({});
  };

  const disableBetaFeatures = () => {
    setFeatures(null);
  };

  const betaFeaturesEnabled = features !== null;

  return {
    isBetaFeatureEnabled,
    setBetaFeatureEnabled,
    enableBetaFeatures,
    disableBetaFeatures,
    betaFeaturesEnabled,
  };
});

export { BetaFeaturesProvider, useBetaFeatures };
